const list = {
  path: 'list',
  component: resolve => require(['../../../../../pages/teacher/course/calendar/list'], resolve)
}
export default list



// WEBPACK FOOTER //
// ./src/router/teacher/course/calendar/list/index.js